import { render, staticRenderFns } from "./SourceChannelListing.vue?vue&type=template&id=a3b2c520"
import script from "./SourceChannelListing.vue?vue&type=script&lang=js"
export * from "./SourceChannelListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports